import axios from '../../http/axios/index.js'

const API_URL = 'https://selfie.cash'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  
  fetchAllUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/allusers`)
        .then((response) => {
          commit('SET_USERS', response.data.allUser)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUserReferral({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/getAllUserReferrals`)
        .then((response) => {
          commit('SET_REFERRALS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPrivateReferral({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/getAllPrivateReferrals`)
        .then((response) => {
          commit('SET_REFERRALS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUsersWithReferral({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/getUsersWithReferral`)
        .then((response) => {
          commit('SET_USERSWITHREFERRAL', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  changeReferStatus({commit}, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/api/management/changeReferStatus`, data)
      .then ((response) => {
        this._vm.$vs.notify({
          color: data.status === 'Approved' ? "success" : "danger",
          title: `Refer is ${data.status}`,
          text: response.data.message,
        });
        commit('CHANGE_REFER_STATUS', data)
        resolve(response)
      })
      .catch((error) => {reject(error)})
    })
  },
  setPrivate ({commit}, data) {
    return new Promise((resolve, reject)  => {
      axios.post (`${API_URL}/api/management/setPrivate`, data)
      .then ((response) => {
        this._vm.$vs.notify({
          color: response.data.data.isPrivate ? "success" : "danger",
          title: `Changed Successfully`,
          text: response.data.message,
        });
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
    })
  },
  getReferralByUser({commit}, data) {
    return new Promise((resolve, reject) => {
      axios.post (`${API_URL}/api/management/getReferralByUser`, data)
      .then((response) => {
        commit('SET_REFERRALS', response.data.referrals)
        resolve(response);
      })
      .catch((error)=>{
        reject(error);
      })
    })
  }
}
